<!-- MAPPA-->
<div class="alert" *ngIf="responseAlert" [ngClass]="responseAlert === 'ok' ? 'alert-ok' : 'alert-ko'">
  <span *ngIf="responseAlert ==='ok'; else ko">
    <span *ngIf="localStorage.getItem('l') === 'it'">Risposta corretta</span>
    <span *ngIf="localStorage.getItem('l') === 'en'">Correct answer</span>
    <span *ngIf="localStorage.getItem('l') === 'fr'">Bonne réponse</span>

    <br><strong>{{citta}}</strong> </span>
  <ng-template #ko>
    <span *ngIf="localStorage.getItem('l') === 'it'">Risposta sbagliata</span>
    <span *ngIf="localStorage.getItem('l') === 'en'">Wrong Answer</span>
    <span *ngIf="localStorage.getItem('l') === 'fr'">Mauvaise réponse</span>
  </ng-template>
</div>
<div class="d-flex flex-wrap mt-3" id="image_wrapper" #mappa>
  <div
    class="mappa-items"
    *ngFor="let item of items"
    [style.backgroundImage]="'url(' + mapImage + ')'"
    [style.backgroundSize]="
      mappaWidth + 'px ' + (mappaWidth * imageHeight) / imageWidth + 'px'
    "
    [style.backgroundPosition]="item.backgroundPosition"
    [style.width]="item?.width + 'px'"
    [style.height]="item?.height + 'px'"
    [style.opacity]="item.opacity"
    [class]="'item-' + item?.id"
    (click)="onSelectMappa(item)"
  ></div>
</div>

<div class="row">
  <div
    class="col-10 offset-1 mt-3 mb-3 p-3 opera"
    *ngFor="let opera of opere; let i = index"
    [class.correctBorder]="opera.found"
    [class.pendingBorder]="this.selectedOpera && !opera.found && this.selectedOpera.id === opera.id"
  >
    <div class="row" (click)="onSelectOpera(opera)">
      <div class="col-4">
        <img
          [src]="opera.immagine"
          [alt]="opera.title"
          class="img-fluid b-block mx-auto"
        />
      </div>
      <div class="col-8 d-flex justify-content-center flex-column">
        <span class="text-primary" *ngIf="opera.found"
          >{{ opera.location }}</span
        >
        <span [innerHTML]="opera.title"></span>
      </div>
    </div>
  </div>
</div>
<!-- MAPPA-->
